/** Color for a "points" value relative to the criterion's maxScore, for quick visual scanning of rule tables. */
export function pointsColor(points, maxScore) {
    if (points === null || points === undefined || points === "") return "text.grey";
    const value = Number(points);
    if (value <= 0) return "red.400";
    if (!maxScore || Number(maxScore) <= 0) return "text.white";
    const ratio = value / Number(maxScore);
    if (ratio < 1 / 3) return "red.400";
    if (ratio < 2 / 3) return "orange.400";
    return "green.400";
}
